export default __webpack_public_path__ + "static/media/bg-signup.3ead492e.jpg";